import type { EmitterLike } from "@infra-blocks/emitter";
import { checkNotNil } from "./check-not-nil.js";
import { type HttpEvents, httpEmitter } from "./http.js";

export type FormSubmissionHandler = ((e: SubmitEvent) => void) &
  EmitterLike<HttpEvents>;

export type Target = URL | string;
export type FetchOptions = Omit<RequestInit, "body">;

export function formSubmissionHandler(
  target: Target,
  options: FetchOptions,
): FormSubmissionHandler {
  const emitter = httpEmitter();

  const handler = (e: SubmitEvent) => {
    e.stopPropagation();
    e.preventDefault();
    const form = checkNotNil(e.target) as HTMLFormElement;
    const formData = new FormData(form);

    const body = new URLSearchParams(
      formData as unknown as Record<string, string>,
    );
    emitter(target, { ...options, body });
  };
  handler.on = (...args: Parameters<typeof emitter.on>) => {
    emitter.on(...args);
    return handler;
  };
  handler.once = (...args: Parameters<typeof emitter.once>) => {
    emitter.once(...args);
    return handler;
  };

  return handler as unknown as FormSubmissionHandler;
}
